<template>
  <!-- <div
    v-if="isLogin && hasOrder"
    class="page-wrapper steps"
  > -->
  <div class="page-wrapper steps gray">
    <Steps
      :steps="steps"
      :current="current"
    />
    <router-view    
      :insuType="insuType"  
      :insuInfo="insuInfo"       
    />
  </div>
</template>

<script>
  import { mapState, mapGetters,mapMutations } from 'vuex';
  import Steps from '@/components/steps/StepRockgp';
  import { checkout } from '@/staticData/steps';

  import { INIT_CHECKOUT_STATE } from '@/store/modules/checkout/constants';

  export default {
    components: { Steps},
    data() {        
      return {
        steps: checkout
      };
    },
    computed: {
      current() {
        const { current } = this.$route.params;       
        return current || 0;
      },
      ...mapState({
        isLogin: ({ user }) => user.isLogin,
        insuType: ({ checkout }) => checkout.insuType,  
        insuInfo: ({ checkout }) => checkout.insuInfos,          
      }),
    },
    mounted() {
      
    },
    methods: {
      ...mapMutations([INIT_CHECKOUT_STATE])
    },
    destroyed() {
      this.INIT_CHECKOUT_STATE();
    },
  };
</script>